// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-2e235682] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.vue-crumb[data-v-2e235682] {
  background-image: none;
  display: inline-flex;
  height: 44px;
  padding: 0;
}
.vue-crumb[data-v-2e235682]:last-child {
  max-width: 210px;
  font-weight: 700;
}
.vue-crumb:last-child .vue-crumb__separator[data-v-2e235682] {
  display: none;
}
.vue-crumb > a[data-v-2e235682]:hover,
.vue-crumb > a[data-v-2e235682]:focus {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}
.vue-crumb--hidden[data-v-2e235682] {
  display: none;
}
.vue-crumb.vue-crumb--hovered > a[data-v-2e235682] {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}
.vue-crumb__separator[data-v-2e235682] {
  padding: 0;
  color: var(--color-text-maxcontrast);
}
.vue-crumb > a[data-v-2e235682] {
  overflow: hidden;
  color: var(--color-text-maxcontrast);
  padding: 12px;
  min-width: 44px;
  max-width: 100%;
  border-radius: var(--border-radius-pill);
  align-items: center;
  display: inline-flex;
  justify-content: center;
}
.vue-crumb > a > span[data-v-2e235682] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item {
  max-width: 100%;
}
.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item .button-vue {
  padding: 0 4px 0 16px;
}
.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item .button-vue__wrapper {
  flex-direction: row-reverse;
}
.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item.action-item--open .action-item__menutoggle {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-b991895f.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;EAEE,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-2e235682] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.vue-crumb[data-v-2e235682] {\n  background-image: none;\n  display: inline-flex;\n  height: 44px;\n  padding: 0;\n}\n.vue-crumb[data-v-2e235682]:last-child {\n  max-width: 210px;\n  font-weight: 700;\n}\n.vue-crumb:last-child .vue-crumb__separator[data-v-2e235682] {\n  display: none;\n}\n.vue-crumb > a[data-v-2e235682]:hover,\n.vue-crumb > a[data-v-2e235682]:focus {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}\n.vue-crumb--hidden[data-v-2e235682] {\n  display: none;\n}\n.vue-crumb.vue-crumb--hovered > a[data-v-2e235682] {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}\n.vue-crumb__separator[data-v-2e235682] {\n  padding: 0;\n  color: var(--color-text-maxcontrast);\n}\n.vue-crumb > a[data-v-2e235682] {\n  overflow: hidden;\n  color: var(--color-text-maxcontrast);\n  padding: 12px;\n  min-width: 44px;\n  max-width: 100%;\n  border-radius: var(--border-radius-pill);\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n}\n.vue-crumb > a > span[data-v-2e235682] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item {\n  max-width: 100%;\n}\n.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item .button-vue {\n  padding: 0 4px 0 16px;\n}\n.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item .button-vue__wrapper {\n  flex-direction: row-reverse;\n}\n.vue-crumb[data-v-2e235682]:not(.dropdown) .action-item.action-item--open .action-item__menutoggle {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
